import {useCallback} from 'react'
import {useWatch} from 'react-hook-form'

import {useFieldConfigurationContext} from '../../configuration/useConfigurationContext'
import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'
import {useConfirmationPin} from '../confirmationPin/useConfirmationPin'

export const useIsConfirmed = () => {
  const {control, setValue, trigger} = useOrderProcessFormContext()
  const {enabled, confirmationPinRequired: confirmationPinRequiredForOrder} =
    useFieldConfigurationContext('isConfirmed')

  const isConfirmed = useWatch({name: 'isConfirmedOrder', control})
  const {confirmationPin, isConfirmationPinEnabled} = useConfirmationPin()
  const defaultIsConfirmed = control._defaultValues.isConfirmedOrder

  const confirmationPinRequired =
    !defaultIsConfirmed && confirmationPinRequiredForOrder && !confirmationPin
  const canConfirmOrder = enabled && (!confirmationPinRequired || isConfirmationPinEnabled)

  const setIsConfirmed = useCallback(
    async (value: boolean) => {
      if (canConfirmOrder) {
        setValue('isConfirmedOrder', value)
        await trigger()
      }
    },
    [canConfirmOrder, setValue, trigger]
  )

  return {
    isConfirmed,
    setIsConfirmed,
    defaultIsConfirmed,
    canConfirmOrder,
    confirmationPinRequired
  }
}
